// removed by extract-text-webpack-plugin
module.exports = {"comment":"_3hvYZ","text":"_1a5RX"};


//////////////////
// WEBPACK FOOTER
// ./app/components/empty-comment/empty-comment.scss
// module id = 1684
// module chunks = 0